export default __webpack_public_path__ + "static/media/f6a5cf87aa72764c.d44d61e1b11db32b7f26dc37083f988f.svg";